"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ErrorPage = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var React = _interopRequireWildcard(require("react"));

var _reactEmotion = _interopRequireDefault(require("react-emotion"));

var _ErrorMessage = _interopRequireDefault(require("../components/ErrorMessage"));

var _errors = require("../errors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  justify-content: center;\n  padding: 40px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var COMPONENT_NAME = 'ErrorPage';
var StyledDiv = (0, _reactEmotion.default)('div')(_templateObject());

var ErrorPage = function ErrorPage(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? _errors.ERROR_UNEXPECTED : _ref$type,
      content = _ref.content,
      header = _ref.header,
      icon = _ref.icon;
  return React.createElement(StyledDiv, {
    className: COMPONENT_NAME
  }, React.createElement(_ErrorMessage.default, {
    type: type,
    content: content,
    header: header,
    icon: icon
  }));
};

exports.ErrorPage = ErrorPage;
var _default = ErrorPage;
exports.default = _default;